import {
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	GET_ALL_BILL_DIRECT_PAYMENT_HEADER_ERROR,
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	GET_ONE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
	ADD_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	ADD_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	ADD_BILL_DIRECT_PAYMENT_HEADER_ERROR,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	UPDATE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
	DELETE_BILL_DIRECT_PAYMENT_HEADER_REQUEST,
	DELETE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
	DELETE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
} from "./types";

import { BASEURL } from "../../constant/config.js";
import moment from "moment";
import { COMPANY_ID } from "../../utils/CompanyId.js";

const axios = require("axios");
export const getAllBillDirectPayment = (token, data) => (dispatch) => {
	
	dispatch({ type: GET_ALL_BILL_DIRECT_PAYMENT_HEADER_REQUEST });
	return axios({
		method: "POST",
		url: `${BASEURL}getAll/payBillDirectPaymentHeader`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: {
			direct_payment_header_no: data.headerNo === "" ? null : data.headerNo,
			from_date: moment(data.from_date).format("MM-DD-YYYY"),
			due_date: moment(data.due_date).format("MM-DD-YYYY"),
			to_date: moment(data.to_date).format("MM-DD-YYYY"),
			account_name: data.account === "" ? null : data.account,
			vendor_name: data.payee === "" ? null : data.payee,
			gl_period_name: data.postingPeriod === "" ? null : data.postingPeriod,
			reference_no: data.referenceNo === "" ? null : data.referenceNo,
			cheaque_no: data.cheaque_no === "" ? null : data.cheaque_no,
			company_id: COMPANY_ID

		},
	})
		.then((response) => {
			return dispatch({
				type: GET_ALL_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ALL_BILL_DIRECT_PAYMENT_HEADER_ERROR,
				payload: error.response,
			});
		});
};

export const getOneBillDirectPayment = (token, id) => (dispatch) => {
	dispatch({ type: GET_ONE_BILL_DIRECT_PAYMENT_HEADER_REQUEST });
	return axios({
		method: "GET",
		url: `${BASEURL}getOne/payBillDirectPaymentHeader/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: GET_ONE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
				payload: response?.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: GET_ONE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
				payload: error.response,
			});
		});
};

export const addBillDirectPayment = (token, formData, companyId) => (dispatch) => {
	
	dispatch({ type: ADD_BILL_DIRECT_PAYMENT_HEADER_REQUEST });
	let newData = {
		payment_date: moment(formData.paymentdate).format("MM-DD-YYYY"),
		account_id: formData.account,
		vendor_id: formData.payee,
		company_id: formData.subsidiary,
		gl_period_id: formData.postingPeriod,
		memo: formData.memo,
		reference_no: formData.RefNo,
		due_date: moment(formData.dueDate).format("MM-DD-YYYY"),
		check_no: formData.checkNo,
		payment_amount: formData.amount,
		
	};
	return axios({
		method: "POST",
		url: `${BASEURL}create/payBillDirectPaymentHeader`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: newData,
	})
		.then((response) => {
			return dispatch({
				type: ADD_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
				payload: response.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: ADD_BILL_DIRECT_PAYMENT_HEADER_ERROR,
				payload: error.response,
			});
		});
};

export const updateBillDirectPayment = (token, formData, id) => (dispatch) => {

	
	let newData = {
		payment_date: moment(formData.paymentdate).format("MM-DD-YYYY"),
		account_id: formData.account,
		vendor_id: formData.payee,
		company_id: formData.subsidiary,
		gl_period_id: formData.postingPeriod,
		memo: formData.memo,
		reference_no: formData.RefNo,
		payment_amount: formData.amount,
	};
	dispatch({ type: UPDATE_BILL_DIRECT_PAYMENT_HEADER_REQUEST });
	return axios({
		method: "PUT",
		url: `${BASEURL}update/payBillDirectPaymentHeader/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: newData,
	})
		.then((response) => {
			
			return dispatch({
				type: UPDATE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
				payloadUpdate: response?.data?.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: UPDATE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
				payloadUpdate: error.response,
			});
		});
};

export const deleteBillDirectPaymentHeader = (token, id) => (dispatch) => {
	dispatch({ type: DELETE_BILL_DIRECT_PAYMENT_HEADER_REQUEST });
	return axios({
		method: "DELETE",
		url: `${BASEURL}delete/payBillDirectPaymentHeader/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
	})
		.then((response) => {
			return dispatch({
				type: DELETE_BILL_DIRECT_PAYMENT_HEADER_SUCCESS,
				payload: response?.data.data,
			});
		})
		.catch((error) => {
			return dispatch({
				type: DELETE_BILL_DIRECT_PAYMENT_HEADER_ERROR,
				payload: error.response,
			});
		});
};
